import { Map } from "immutable";
import React from "react";
import { CircleLoader } from "react-spinners";
import Customer from "../components/boatparking/Customer";
import BkContentArea from "../components/layout/BkContentArea";
import BkModifyButton from "../components/layout/BkModifyButton";
import { genericPost } from "../services/axiosApi";
import LanguageSelection from "../components/boatparking/LanguageSelection";

class RaaseporiForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: Map(),
      saveDisabled: true,
      saving: false,
      saved: false
    };
    props.getTranslations("booking-web", this.props.location.language, "reserve");
    this.renderAccount = this.renderAccount.bind(this);
    this.save = this.save.bind(this);
    this.updateCustomer = this.updateCustomer.bind(this);
  }
  save() {
    genericPost("fi", "userform", this.state.customer).then(r => {
      if (!r.errorStatus) {
        this.setState({ saving: false, saved: true });
      } else {
        this.setState({
          saving: false,
          errorMessage: r.errorMessage
            ? r.errorMessage
            : "Tallennuksessa tapahtui virhe. Tarkista arvot ja yritä uudestaan."
        });
      }
    });
  }
  render() {
    const l = this.props.location; // shortcut
    const t = key => l.translate(l, key);

    if (t("close-button") === "close-button") {
      setTimeout(() => {
        if (t("close-button") === "close-button") {
          this.props.getTranslations("booking-web", l.language, "reserve");
        }
      }, 2);
      return <CircleLoader />;
    }

    return this.renderAccount(t);
  }

  renderAccount(t) {

    const svt = key => {
      if (key == "firstName") {
        return "Förnamn / etunimi:";
      } else if (key == "lastName") {
        return "Efternamn / sukunimi:";
      } else if (key == "email") {
        return "E-post / sähköposti:";
      } else if (key == "repeatEmail") {
        return "E-post igen / sähköposti uudelleen:";
      } else if (key == "mobile") {
        return "Telefon / puhelin:";
      } else if (key == "streetAddress") {
        return "Address / katuosoite:";
      } else if (key == "postOffice") {
        return "Postnummer / postinumero:";
      } else if (key == "town") {
        return "Postkontor / postitoimipaikka:";
      } else if (key == "boatRegister") {
        return "Båtens registernummer (eller beskrivning) / veneen rek.nro (tai kuvaus):";
      } else if (key == "boatName") {
        return "Båtens namn / veneen nimi:";
      } else if (key == "boatSize") {
        return "Båtens storlek / veneen koko (metriä):";
      } else if (key == "boatLength") {
        return "Längd/pituus";
      } else if (key == "boatWidth") {
        return "Bredd/leveys";
      } else if (key == "boatDepth") {
        return "Djup/syväys";
      } else if (key == "boatType") {
        return "Båttyp / veneen tyyppi";
      } else {
        return t(key);
      }
    }

    return (
      <BkContentArea>
        <center style={{ marginRight: "50px" }}>
          <div className="bkProfile-leftColumn">
            <div className="togglecontainer">
              <section>
                <div className="single_toggle">
                  <div className="bk-special-heading">
                    <img src="/raasepori.png" alt="" style={{ width: "150px", backgroundColor: "#5B7B32", padding: "5px" }} />
                    <h3 className="column-title">Egna båtuppgifter / Omat venepaikkatiedot</h3>
                  </div>
                  {this.state.saved && (
                    <div className="bk_okMessage">
                      Data har sparats. Du kan stänga webbläsaren.<br/>
                      Tiedot tallennettu onnistuneesti. Voit sulkea selaimen.
                    </div>
                  )}
                  {!this.state.saved && (
                    <React.Fragment>
                      {this.state.errorMessage && (
                        <div className="bk_errorMessage display">
                          {this.state.errorMessage}
                        </div>
                      )}
                      <br style={{ clear: "both" }} />
                      <div className="bk_placeDetails">
                        <p style={{ textAlign: "left" }}>
                        Fyll i dina kontakt- och båtuppgifter i fälten nedanom. 
                        De obligatoriska fälten är märkta med en stjärna (*). 
                        På basen av dina inlämnade uppgifter skickar vi en platsspecifik 
                        bokningslänk med mera information och en länk för betalning av båtplatsen. 
                        Observera att du inte är bunden att ta emot platsen bara genom att fylla i blanketten.
                        </p>
                        <p style={{ textAlign: "left" }}>
                          Täytä alla oleviin kenttiin yhteys- ja venetietonne.
                          Pakolliset kentät on merkitty tähdellä (*). Lähetämme
                          myöhemmin lomakkeella ilmoitettuun sähköpostiin
                          paikkakohtaisen varauslinkin, jonka kautta voit maksaa
                          venepaikkasi. Lomakkeen tiedot eivät sido ottamaan
                          paikkaa vastaan.
                        </p>
                      </div>
                      <Customer
                        t={svt}
                        autocomplete={true}
                        updateCustomer={(field, value) =>
                          this.updateCustomer(field, value)
                        }
                        stateCustomer={this.state.customer}
                        renderAsTable={true}
                        showAddress={true}
                        requireAddress={true}
                        repeatEmail={true}
                        askBoatSize={true}
                        boatRegister={true}
                        boatOptional={true}
                        {...this.props}
                      />

                      <div className="bk_placeDetails">
                        <center>
                          <label>*Hamn / satama</label>
                        </center>
                        <center>
                          <select
                            onInput={e =>
                              this.updateCustomer("harbour", e.target.value)
                            }
                            onChange={e =>
                              this.updateCustomer("harbour", e.target.value)
                            }
                          >
                            <option value="">- välj / valitse -</option>
                            <option>Norra hamnen / Pohjoissatama</option>
                            <option>Gumnäs</option>
                            <option>Svartå / Mustio</option>
                            <option>Flyet</option>
                            <option>Jägarbacken / Metsästäjänmäki</option>
                            <option>Ormnäs</option>
                            <option>Södra viken / Etelälahti</option>
                            <option>Pojo</option>
                          </select>
                        </center>
                      </div>
                      <br />
                      <BkModifyButton
                        disabled={this.state.saveDisabled}
                        busy={this.state.saving}
                        buttonTitle="Spara / Tallenna"
                        callback={this.save}
                      />
                    </React.Fragment>
                  )}
                </div>
              </section>
            </div>
            <div
              className="bk-guest-rental-footer"
              style={{ position: "static" }}
            >
              <a
                href="https://www.raasepori.fi/etusivu/tietosuojaseloste/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Tietosuoja
              </a>{" "}
              <a
                href="https://www.raseborg.fi/hem/dataskyddsbeskrivning/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Dataskyddsbeskrivning
              </a>{" "}
              | raasepori@raasepori.fi
            </div>
          </div>
        </center>
      </BkContentArea>
    );
  }
  updateCustomer(fieldName, value) {
    const c = this.state.customer.set(fieldName, value);
    this.setState({
      customer: c,
      saveDisabled:
        this.requiredDataMissing(c) || c.get("email") !== c.get("repeatEmail")
    });
  }
  requiredDataMissing(c) {
    console.log(JSON.stringify(c));
    return (
      !c.get("harbour") ||
      !c.get("firstName") ||
      !c.get("lastName") ||
      !c.get("mobile") ||
      !c.get("email") ||
      !c.get("streetAddress") ||
      !c.get("town") ||
      !c.get("postOffice")
    );
  }
}

export default RaaseporiForm;
